module.exports = __webpack_public_path__ + "static/media/yellow_arrow.9ada57a3.svg";